import { render, staticRenderFns } from "./RetiredCrewVirtualAwardingCeremony.vue?vue&type=template&id=15468da6&scoped=true"
import script from "./RetiredCrewVirtualAwardingCeremony.vue?vue&type=script&lang=js"
export * from "./RetiredCrewVirtualAwardingCeremony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15468da6",
  null
  
)

export default component.exports